import React, { Component } from "react";
import { Grid } from "@mui/material";

class CreatePassword extends Component {
  state = { showPassword: false };

  constructor(props) {
    super(props);
    this.showPassword = this.showPassword.bind(this);
    this.hidePassword = this.hidePassword.bind(this);
  }

  showPassword() {
    this.setState({
      showPassword: true,
    });
  }

  hidePassword() {
    this.setState({
      showPassword: false,
    });
  }

  render() {
    const { updatePassword } = this.props;
    const { showPassword } = this.state;
    return (
      <Grid container alignItems="center" justify="center">
        <Grid item xs={12}>
          <input
            name="password"
            type={showPassword ? "text" : "password"}
            className="textbox logintext"
            onChange={updatePassword}
          />
        </Grid>
        <Grid item xs={12}>
          {showPassword ? (
            <img
              src="https://img.icons8.com/nolan/64/hide.png"
              className="icon_button"
              alt="Hide Password"
              onClick={this.hidePassword}
            />
          ) : (
            <img
              src="https://img.icons8.com/nolan/64/visible.png"
              className="icon_button"
              alt="Show Password"
              onClick={this.showPassword}
            />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default CreatePassword;
